import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export enum BrakeSevereComparisonGraphType {
  GOOD = 'type_good',
  CAUTION = 'type_caution',
  WARNING = 'type_warning',
  NODATA = 'type_nodata',
}

interface BrakeSevereComparisonGraphProps {
  severeTripCount: number | string | null | undefined;
  averageSevereTripCount: number | string | null | undefined;
  severeGraphRatio: number;
  averageGraphRatio: number;
  severeGraphType: BrakeSevereComparisonGraphType;
}

function BrakeSevereComparisonGraph({
  severeTripCount,
  averageSevereTripCount,
  severeGraphRatio,
  averageGraphRatio,
  severeGraphType,
}: BrakeSevereComparisonGraphProps) {
  const {t} = useInferableTranslation();
  return (
    <div className="brakepad_graph_area">
      <div className={`brakepad_graph ${severeGraphType}`}>
        <span className="brakepad_graph_bar my_brake">
          <span
            className="bar_current"
            style={{width: `${severeGraphRatio * 100}%`}}
          >
            <span className="blind">{t('T30144')}</span>
            <span className="speech_bubble">{t('T30145_$count', {count: severeTripCount})}</span>
          </span>
        </span>
        <span className="brakepad_graph_bar average_brake">
          <span
            className="bar_current"
            style={{width: `${averageGraphRatio * 100}%`}}
          />
        </span>
      </div>
      <span className="brakepad_average">
        {t('T30146')}
        <span className="average_value">{t('T30145_$count', {count: averageSevereTripCount})}</span>
      </span>
    </div>
  );
}

export default BrakeSevereComparisonGraph;
